import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { userAutoLoginAction } from './store/user.actions';
import { Store } from '@ngrx/store';
import * as fromApp from './app.reducer';
import { getStoredUser } from './store/storage.meta-reducer';
import { APP_ORGANIZATION_CODE } from 'app/common';
import { authPath } from 'app/constants/pages-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  organizationId = '';

  constructor(
    private router: Router,
    private store: Store<fromApp.AppState>,
    @Inject(APP_ORGANIZATION_CODE) private organizationCode: string
  ) {
  }

  /**
   * Если не авторизован, то редирект на авторизацию ссылкой на возврат
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const cachedUser = getStoredUser(this.organizationCode);
    if (cachedUser.isAuthorized) {
      // авторизуем только если до этого была другая организация,
      // или не было никакой, чтоб не плодить запросов
      if (this.organizationId !== this.organizationCode) {
        this.organizationId = this.organizationCode;
        this.store.dispatch(userAutoLoginAction(cachedUser));
      }
      return true;
    } else {
      return this.router.createUrlTree(['/', authPath], {
        queryParams: {
          'backUrl': state.url
        }
      });
    }
  }
}
